import '.ac{position:relative;}.ssr-plugin'
import '.cb{display:inline-flex;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.e4{align-self:flex-start;}.ssr-plugin'
import '.e5{padding:3px;}.ssr-plugin'
import '.e6{background:var(--palette-blue-50);}.ssr-plugin'
import '.e7{border:0.5px solid var(--gray-200);}.ssr-plugin'
import '.cp{border-radius:0.75rem;}.ssr-plugin'
import '.be{position:absolute;}.ssr-plugin'
import '.e8{top:3px;}.ssr-plugin'
import '.bg{left:0px;}.ssr-plugin'
import '.e9{width:0px;}.ssr-plugin'
import '.ea{height:calc(100% - 6px);}.ssr-plugin'
import '.e1{background:var(--palette-white);}.ssr-plugin'
import '.eb{border:0.5px solid var(--gray-300);}.ssr-plugin'
import '.ec{border-radius:calc(0.75rem - 3px);}.ssr-plugin'
import '.ed{box-shadow:0 1px 3px rgba(0, 0, 0, 0.08);}.ssr-plugin'
import '.cn{pointer-events:none;}.ssr-plugin'
import '.ee{z-index:1;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.ai{justify-content:center;}.ssr-plugin'
import '.ef{gap:0.375rem;}.ssr-plugin'
import '.eg{padding-block:6px;}.ssr-plugin'
import '.eh{padding-inline:18px;}.ssr-plugin'
import '.ct{background:transparent;}.ssr-plugin'
import '.ay{border:none;}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import '.df{user-select:none;}.ssr-plugin'
import '.ei{white-space:nowrap;}.ssr-plugin'
import '.al{flex:1;}.ssr-plugin'
import { useCallback, useLayoutEffect, useRef } from 'react'
import { Style, styled } from 'inlines'
import { Text } from '../typography/Text'

export type ToggleOption<T> = {
  label: string
  value: T
  style?: Style
}

export type ToggleProps<T> = {
  options: ToggleOption<T>[]
  selectedOption: T
  setSelectedOption: (option: T) => void
  style?: Style
}

const PILL_TRANSITION =
  'left 0.28s cubic-bezier(0.34, 1.3, 0.64, 1), width 0.28s cubic-bezier(0.34, 1.3, 0.64, 1)'

export const Toggle = <T extends string | boolean>({
  options,
  selectedOption,
  setSelectedOption,
  style,
}: ToggleProps<T>) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const pillRef = useRef<HTMLDivElement>(null)
  const itemRefs = useRef<(HTMLButtonElement | null)[]>([])

  const updatePill = useCallback(() => {
    const selectedIndex = options.findIndex(
      (option) => option.value === selectedOption,
    )
    const activeEl = itemRefs.current[selectedIndex]
    const pill = pillRef.current

    if (!activeEl || !pill) {
      return
    }

    pill.style.left = `${activeEl.offsetLeft}px`
    pill.style.width = `${activeEl.offsetWidth}px`
  }, [options, selectedOption])

  useLayoutEffect(() => {
    const container = containerRef.current
    if (!container) {
      return
    }

    updatePill()

    const observer = new ResizeObserver(() => {
      updatePill()
    })
    observer.observe(container)

    return () => observer.disconnect()
  }, [updatePill])

  return (
    <styled.div className="ac cb t e4 e5 e6 e7 cp"
      ref={containerRef}
      style={{
        ...style,
      }}
    >
      <div className="be e8 bg e9 ea e1 eb ec ed cn"
        ref={pillRef}
        aria-hidden="true"
        style={{
          transition: PILL_TRANSITION,}}
      />
      {options.map((option, index) => {
        const isActive = selectedOption === option.value

        return (
          <styled.button className="ac ee d t ai ef eg eh ct ay ec a1 df ei al"
            key={String(option.value)}
            type="button"
            ref={(element) => {
              itemRefs.current[index] = element
            }}
            onClick={() => setSelectedOption(option.value)}
            style={{
              ...(!isActive && {
                '&:hover span': {
                  color: 'var(--brand-secondary)',
                },
              }),
              ...option.style,
            }}
          >
            <Text.Medium
              color={
                isActive
                  ? 'var(--brand-secondary)'
                  : 'var(--palette-blue-400)'
              }
              isBold={isActive}
              style={{ transition: 'color 0.18s' }}
            >
              {option.label}
            </Text.Medium>
          </styled.button>
        )
      })}
    </styled.div>
  )
}
